import React, { SyntheticEvent } from "react";
import { Autocomplete, AutocompleteProps, TextField, TextFieldProps } from "@mui/material";
import { AutoCompleteOptionWithId } from "../../types/AutoCompleteOptionWithId";
import { AutoCompleteOptionWithValue } from "../../types/AutoCompleteOptionWithValue";

export type LegalbirdAutoCompleteProps<TOption> = {
  setValue: (event: SyntheticEvent, value: TOption | null) => void;
  label: string;
  onFocus?: TextFieldProps["onFocus"];
  textFieldProps?: TextFieldProps;
  textFieldStyles?: TextFieldProps["sx"];
} & Omit<AutocompleteProps<TOption, false, boolean, false, React.ElementType>, "renderInput">;

export function LegalbirdAutoComplete<TOption extends AutoCompleteOptionWithValue | AutoCompleteOptionWithId>({
  setValue,
  label = "",
  onFocus = () => {},
  textFieldProps,
  textFieldStyles = {},
  ...rest
}: LegalbirdAutoCompleteProps<TOption>) {
  return (
    // @ts-ignore TODO - Check if type is fixable
    <Autocomplete<TOption, false, boolean, false>
      renderInput={(params) => (
        <TextField
          {...params}
          onFocus={onFocus}
          label={label}
          sx={{ ...textFieldStyles }}
          {...textFieldProps}
        />
      )}
      getOptionLabel={(option: TOption) => {
        if (!option) {
          return "";
        }
        return option.label;
      }}
      disableClearable
      onChange={setValue}
      {...rest}
    />
  );
}

export default LegalbirdAutoComplete;
